module.exports = __webpack_public_path__ + "assets/successNote3-b44081.svg";